import React from 'react';
import Holiday_List from './Holiday_List';
import '../../../CommonCSS/SocietyCSS.css'

const Holiday_ListApp = () => {
  return (
    // <div className="App">
    //   <Common_Mst />
    // </div>
    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Holiday List </h5>
          </div>  
        </div>
        <Holiday_List/>
      </div>
    </div >
  );
};

export default Holiday_ListApp;
